module.exports = __webpack_public_path__ + "assets/024c6976e01d8b5a844f72cac48cd297.mp3";